import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { contactus } from 'src/app/core/translations/contactus';
import { environment } from 'src/environments/environment';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  isHandsetPortrait: boolean = false;
  formOne: boolean = true;
  formTwo: boolean = false;

  bannerImage: any ='';
  bannerClass: any ='';
  currentLanguage: string = '';
  languageTranslations: any = contactus;
  activeLanguageTranslations: any = {};
  contactForm!: FormGroup;
  feedbackForm!: FormGroup;
  subscribeForm!: FormGroup;
  subscribed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.initFeebackForm();
    this.initSubscribeForm();
    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];
      }
    }
  }
 initForm(){
  this.contactForm = this.fb.group({
    firstName: ['',Validators.required],
    lastName: ['',Validators.required],
    emailID: ['',[Validators.required,Validators.email]],
    phone: [''],
    message: ['',Validators.required],
    subscription: false,
    captcha: ['',Validators.required]
  });
}

initFeebackForm(){
  this.feedbackForm = this.fb.group({
    timestamp: [new Date()],
    firstName: ['',Validators.required],
    lastName: ['',Validators.required],
    emailID: ['',[Validators.required,Validators.email]],
    phone: [''],
    newDesign: ['',Validators.required],
    navigateWebsite:['',Validators.required],
    compareWebsite:['',Validators.required],
    nativeDevices:['',Validators.required],
    keyPoints:['',Validators.required],
    websiteFeature:['',Validators.required],
    subscription: false,
    message: ['',Validators.required],
    captcha: ['',Validators.required]
  });
}

initSubscribeForm(){
this.subscribeForm = this.fb.group({
  emailID: ['',[Validators.required,Validators.email]],
  firstName:['',Validators.required]
})
}

  resolved(captchaResponse: string) {
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
  
  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }


  submitted: boolean = false;

  submittedError: boolean = false;
  submitText: any='Submit';
  subscribeText: any='Subscribe';

  onSubscribe(): any{
    this.subscribeForm.markAllAsTouched()
    if(!this.subscribeForm.valid){
      return '';
    }
    this.subscribeText = "Subscribing..";
    this.dashboardService.subscribeLetter(this.subscribeForm.value).subscribe({
      next: (val)=>{
        this.subscribeText = "Subscribe";
        this.subscribed = true;
        this.subscribeForm.reset();
        setTimeout(() => {
          this.subscribed = false;
        }, 5000);
    },error:(err: any)=>{
      this.subscribeText = "Subscribe";
    }})
  
  }


  onSubmit(a:any): any{
    this.contactForm.markAllAsTouched()
    if(!this.contactForm.valid){
      return '';
    }
  

    this.submitText = "Submitting..";
    this.dashboardService.createContactUs(this.contactForm.value).subscribe(val=>{})

    this.dashboardService
      .contactUs(this.contactForm.value,1)

      .subscribe((res: any) => {
            this.submitText = "Submit";
            this.submitted = true;
            this.contactForm.reset();
            setTimeout(() => {
              this.submitted = false;
            }, 5000);
        },(err: any) => {
          // console.log('error in sending email ', err);
          this.submitText = "Submit";
          this.submittedError = true;

          setTimeout(() => {
            this.submittedError = false;
          }, 5000);
        }
      );

    
  }

  onSubmitFeedback(): any{
    this.feedbackForm.markAllAsTouched();
    if(!this.feedbackForm.valid){
      return '';
    }
    // console.log(this.feedbackForm.value)
  //  let api = 'https://script.google.com/macros/s/AKfycbzxDtmYcJaUEGTbfRAQeOkMw2AXeFCjQyeM8rIVOi9PBFGKQMRJgZI1T0kIxxflmO3-jQ/exec';
  this.submitText = "Submitting..";
   const api = 'https://script.google.com/macros/s/AKfycbyzhQcoQ_Utayw65ENSVgZoSfEglsPD5VdG9StkJ24YSkoOD2AhL3lFqzOxgpSZvTBaMQ/exec';
   fetch(api,{
    method:'POST',
    body:JSON.stringify(this.feedbackForm.value),
    mode: 'no-cors'
   }).then(res=>res.text()).then(data=>{
    this.feedbackForm.reset();
    this.submitted = true;
    this.submitText = "Submit";
    setTimeout(() => {
      this.submitted = false;
    }, 5000);
   });

  }



  changeColor(event: any) {

    // console.log(event.target.value);
    if(event.target.value == 1){
      this.formOne = true;
      this.formTwo = false;
    }else{
      this.formOne = false;
      this.formTwo = true;
    }
  }


}
